import React, { lazy } from 'react';
import { clientMenu, adminMenu, demoPagesMenu, pageLayoutTypesPagesMenu } from '../menu';
import Login from '../pages/presentation/auth/Login';
import EncryptText from '../pages/presentation/auth/EncryptText';
import ForgotPassword from '../pages/presentation/auth/ForgotPassword';
import ResetPassword from '../pages/presentation/auth/ResetPassword';
import CreateAccount from '../pages/presentation/auth/CreateAccount';
import AdminRouteGuard from './AdminRouteGuard';
// import CreateAccount2 from '../pages/presentation/auth/CreateAccount2';
// import CreateAccount3 from '../pages/presentation/auth/CreateAccount3';
// import TopXLoosers from '../pages/presentation/admin/reports/TopXLoosersPage';
// import { element } from 'prop-types';

const CLIENT_LANDING = {
	DASHBOARD: lazy(() => import('../pages/presentation/client/dashboard/DashboardPage')),
	DOCUMENTS: lazy(() => import('../pages/presentation/client/documents/DocumentsPage')),
	PLATFORMS: lazy(() => import('../pages/presentation/client/platforms/PlatformsPage')),
	HISTORY: lazy(() => import('../pages/presentation/client/history/HistoryPage')),
	WITHDRAW: lazy(() => import('../pages/presentation/client/withdraw/WithdrawPage')),
	LOAN: lazy(() => import('../pages/presentation/client/loan/LoanPage')),
	DEPOSIT: lazy(() => import('../pages/presentation/client/deposit/deposit')),
	RECENTACTIVITIES: lazy(
		() => import('../pages/presentation/client/recentactivities/RecentactivitiesPage'),
	),
	MARGINCALCULATOR: lazy(
		() => import('../pages/presentation/client/margincalculator/MarginCalculator'),
	),
	Mail: lazy(() => import('../pages/presentation/client/mail/MailPage')),
	EDUCATIONCENTER: lazy(
		() => import('../pages/presentation/client/educationcenter/EducationCenterPage'),
	),
	// NEWS: lazy(() => import('../pages/presentation/client/news/NewsPage')),
};

const CLIENT_ANALYSIS = {
	CHARTWIDGET: lazy(() => import('../pages/presentation/client/analysis/ChartWidgetPage')),
	ECONOMICCALENDAR: lazy(
		() => import('../pages/presentation/client/analysis/EconomicCalendarPage'),
	),
	TICKER: lazy(() => import('../pages/presentation/client/analysis/TickerPage')),
};

const ADMIN_LANDING = {
	DASHBOARD: lazy(() => import('../pages/presentation/admin/dashboard/DashboardPage')),
	CUSTOMER: lazy(() => import('../pages/presentation/admin/customer/CustomerPage')),
	CLIENTS: lazy(() => import('../pages/presentation/admin/clients/ClientsPage')),
	USERCUSTOMDATA: lazy(() => import('../pages/presentation/admin/UserCustomDataPage')),
	MARGINCALL: lazy(() => import('../pages/presentation/admin/MarginCallPage')),
	LEADS: lazy(() => import('../pages/presentation/admin/leads/LeadsPage')),
	LEADASSIGNMENTS: lazy(() => import('../pages/presentation/admin/leads/LeadAssignment')),
	CLICKTOCALLAGENTMAPPINGS: lazy(
		() => import('../pages/presentation/admin/leads/ClickToCallAgentMappingPage'),
	),
	CLICKTOCALLHISTORY: lazy(
		() => import('../pages/presentation/admin/leads/ClickToCallHistoryPage'),
	),
	BANKS: lazy(() => import('../pages/presentation/admin/banks/BanksPage')),
	WITHDRAW: lazy(() => import('../pages/presentation/admin/withdraw/WithdrawPage')),
	DEPOSIT: lazy(() => import('../pages/presentation/admin/deposit/DepositPage')),
	LOAN: lazy(() => import('../pages/presentation/admin/loan/LoanPage')),
	MAIL: lazy(() => import('../pages/presentation/admin/mail/MailListPage')),
	EDUCATIONCENTER: lazy(
		() => import('../pages/presentation/admin/educationcenter/EducationCenterPage'),
	),
	RECENTACTIVITIES: lazy(
		() => import('../pages/presentation/admin/recentactivities/RecentactivitiesPage'),
	),
	OTPSERVICE: lazy(() => import('../pages/presentation/admin/otpService/OtpServicePage')),
	TRANSACTIONAL_SMS_PROVIDERS: lazy(
		() =>
			import(
				'../pages/presentation/admin/transactionalSmsProviders/TransactionalSmsProvidersPage'
			),
	),
	// PUBLICSETTINGS: lazy(() => import('../pages/presentation/admin/settings/SettingsPage')),
};
const ADMIN_REPORTS = {
	REPORTSHUB: lazy(() => import('../pages/presentation/admin/reports/ReportsHubPage')),
	TRANSACTIONSREPORT: lazy(
		() => import('../pages/presentation/admin/reports/TransactionsReportPage'),
	),
	MONEYTRANSACTIONSREPORT: lazy(
		() => import('../pages/presentation/admin/reports/MoneyTransactionsReportPage'),
	),

	FirstDeposit: lazy(() => import('../pages/presentation/admin/reports/FirstDepositPage')),
	REPEATEDDEPOSIT: lazy(() => import('../pages/presentation/admin/reports/RepeatedDepositPage')),
	TODAYSLIQUIDATEACCOUNT: lazy(
		() => import('../pages/presentation/admin/reports/TodaysLiquidateAccountPage'),
	),
	ACTIVEACCOUNTSWITHFUNDS: lazy(
		() => import('../pages/presentation/admin/reports/ActiveAccountsWithFundsPage'),
	),
	SEMIIACTIVEACCOUNTS: lazy(
		() => import('../pages/presentation/admin/reports/SemiInactiveAccountsPage'),
	),
	INACTIVEACCOUNTSWITHFUNDS: lazy(
		() => import('../pages/presentation/admin/reports/InactiveAccountsWithFundsPage'),
	),
	TOPXWINNERS: lazy(() => import('../pages/presentation/admin/reports/TopXWinnersPage')),
	TOPXLOOSERS: lazy(() => import('../pages/presentation/admin/reports/TopXLoosersPage')),

	ACCOUNTWITHOUTMONEYTRANSACTION: lazy(
		() => import('../pages/presentation/admin/reports/NoFTDAccountsPage'),
	),

	USERSDETAILSREPORT: lazy(
		() => import('../pages/presentation/admin/reports/UsersDetailsReportPage'),
	),
	DETAILEDOPENPOSITIONSREPORT: lazy(
		() =>
			import(
				'../pages/presentation/admin/reports/OpenPositionsReport/DetailedOpenPositionsReportPage'
			),
	),
	DETAILEDOPENHISTORYREPORT: lazy(
		() =>
			import(
				'../pages/presentation/admin/reports/HistoryReport/DetailedOpenHistoryReportPage'
			),
	),
	DETAILEDCLOSEHISTORYREPORT: lazy(
		() =>
			import(
				'../pages/presentation/admin/reports/HistoryReport/DetailedCloseHistoryReportPage'
			),
	),
	PENDINGORDERSREPORT: lazy(
		() => import('../pages/presentation/admin/reports/PendingOrdersReportPage'),
	),
	DETAILEDFINANCIALSTANDINGREPORT: lazy(
		() =>
			import(
				'../pages/presentation/admin/reports/FinancialStandingReport/DetailedFinancialStandingReportPage'
			),
	),
	FINANCIALSTANDINGHISTORYREPORT: lazy(
		() =>
			import(
				'../pages/presentation/admin/reports/FinancialStandingReport/FinancialStandingHistoryReportPage'
			),
	),
	OTPLOGSREPORT: lazy(() => import('../pages/presentation/admin/reports/OtpLogsReportPage')),
	LOGINREPORT: lazy(() => import('../pages/presentation/admin/reports/LoginReportPage')),
	DEALERCALLACTIVITYREPORT: lazy(
		() => import('../pages/presentation/admin/reports/DealerCallActivityReportPage'),
	),

	OPENROBOORDERSHISTORY: lazy(
		() =>
			import(
				'../pages/presentation/admin/reports/RoboOrdersHistory/OpenRoboOrdersHistoryPage'
			),
	),
	CLOSEROBOORDERSHISTORY: lazy(
		() =>
			import(
				'../pages/presentation/admin/reports/RoboOrdersHistory/CloseRoboOrdersHistoryPage'
			),
	),
	WITHDRAWREQUESTSREPORT: lazy(
		() => import('../pages/presentation/admin/reports/WithdrawRequestsReportPage'),
	),
	DEPOSITREQUESTREPORT: lazy(
		() => import('../pages/presentation/admin/reports/DepositRequestReportPage'),
	),
	CLIENTDEPOSITSUMMARYREPORT: lazy(
		() => import('../reportPages/ClientDepositSummaryReportPage'),
	),
	FAILEDDEPOSITSREPORT: lazy(
		() => import('../pages/presentation/admin/reports/FailedDepositsReportPage'),
	),
	LOANREQUESTSREPORT: lazy(
		() => import('../pages/presentation/admin/reports/LoanRequestsReportPage'),
	),
	JOURNALREPORT: lazy(() => import('../pages/presentation/admin/reports/JournalReportPage')),
};

const AUTH = {
	PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
};
const PAGE_LAYOUTS = {
	HEADER_SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/HeaderAndSubheader')),
	HEADER: lazy(() => import('../pages/presentation/page-layouts/OnlyHeader')),
	SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/OnlySubheader')),
	CONTENT: lazy(() => import('../pages/presentation/page-layouts/OnlyContent')),
	BLANK: lazy(() => import('../pages/presentation/page-layouts/Blank')),
	ASIDE: lazy(() => import('../pages/presentation/aside-types/DefaultAsidePage')),
	MINIMIZE_ASIDE: lazy(() => import('../pages/presentation/aside-types/MinimizeAsidePage')),
};

const presentation = [
	/**
	 * Landing
	 */
	{
		path: clientMenu.dashboard.path,
		element: <CLIENT_LANDING.DASHBOARD />,
	},
	// {
	// 	path: clientMenu.documents.path,
	// 	element: <CLIENT_LANDING.DOCUMENTS />,
	// },
	{
		path: clientMenu.history.path,
		element: <CLIENT_LANDING.HISTORY />,
	},
	{
		path: clientMenu.analysis.subMenu.chartWidget.path,
		element: <CLIENT_ANALYSIS.CHARTWIDGET />,
	},
	{
		path: clientMenu.analysis.subMenu.economicCalendar.path,
		element: <CLIENT_ANALYSIS.ECONOMICCALENDAR />,
	},
	{
		path: clientMenu.analysis.subMenu.ticker.path,
		element: <CLIENT_ANALYSIS.TICKER />,
	},
	{
		path: clientMenu.platforms.path,
		element: <CLIENT_LANDING.PLATFORMS />,
	},
	{
		path: clientMenu.withdraw.path,
		element: <CLIENT_LANDING.WITHDRAW />,
	},
	{
		path: clientMenu.loan.path,
		element: <CLIENT_LANDING.LOAN />,
	},
	{
		path: clientMenu.deposit.path,
		element: <CLIENT_LANDING.DEPOSIT />,
	},
	{
		path: clientMenu.marginCalculator.path,
		element: <CLIENT_LANDING.MARGINCALCULATOR />,
	},
	{
		path: clientMenu.mail.path,
		element: <CLIENT_LANDING.Mail />,
	},
	{
		path: clientMenu.educationcenter.path,
		element: <CLIENT_LANDING.EDUCATIONCENTER />,
	},
	{
		path: '/client/recentactivities',
		element: <CLIENT_LANDING.RECENTACTIVITIES />,
	},
	// {
	// 	path: clientMenu.news.path,
	// 	element: <CLIENT_LANDING.NEWS />,
	// },

	{
		path: adminMenu.dashboard.path,
		element: <ADMIN_LANDING.DASHBOARD />,
	},
	// {
	// 	path: `${adminMenu.customer.path}/:username`,
	// 	element: <ADMIN_LANDING.CUSTOMER />,
	// },
	{
		path: adminMenu.clients.path,
		element: <ADMIN_LANDING.CLIENTS />,
	},
	{
		path: adminMenu.integrations.subMenu.userCustomData.path,
		element: (
			<AdminRouteGuard permissionKey='userCustomData'>
				<ADMIN_LANDING.USERCUSTOMDATA />
			</AdminRouteGuard>
		),
	},
	{
		path: adminMenu.marginCall.path,
		element: (
			<AdminRouteGuard permissionKey='marginCall'>
				<ADMIN_LANDING.MARGINCALL />
			</AdminRouteGuard>
		),
	},
	{
		path: adminMenu.leads.path,
		element: (
			<AdminRouteGuard permissionKey='allLeads'>
				<ADMIN_LANDING.LEADS />
			</AdminRouteGuard>
		),
	},
	{
		path: adminMenu.leads.subMenu.allLeads.path,
		element: (
			<AdminRouteGuard permissionKey='allLeads'>
				<ADMIN_LANDING.LEADS />
			</AdminRouteGuard>
		),
	},
	{
		path: adminMenu.leads.subMenu.leadAssignments.path,
		element: (
			<AdminRouteGuard permissionKey='leadAssignments'>
				<ADMIN_LANDING.LEADASSIGNMENTS />
			</AdminRouteGuard>
		),
	},
	{
		path: adminMenu.clickToCall.subMenu.agentMappings.path,
		element: (
			<AdminRouteGuard permissionKey='agentMappings'>
				<ADMIN_LANDING.CLICKTOCALLAGENTMAPPINGS />
			</AdminRouteGuard>
		),
	},
	{
		path: '/admin/leads/agentMappings',
		element: (
			<AdminRouteGuard permissionKey='agentMappings'>
				<ADMIN_LANDING.CLICKTOCALLAGENTMAPPINGS />
			</AdminRouteGuard>
		),
	},
	{
		path: adminMenu.clickToCall.subMenu.callHistory.path,
		element: (
			<AdminRouteGuard permissionKey='clickToCallHistory'>
				<ADMIN_LANDING.CLICKTOCALLHISTORY />
			</AdminRouteGuard>
		),
	},
	{
		path: adminMenu.banks.path,
		element: <ADMIN_LANDING.BANKS />,
	},
	{
		path: adminMenu.otpService.path,
		element: (
			<AdminRouteGuard permissionKey='otpService'>
				<ADMIN_LANDING.OTPSERVICE />
			</AdminRouteGuard>
		),
	},
	{
		path: adminMenu.analysis.subMenu.chartWidget.path,
		element: <CLIENT_ANALYSIS.CHARTWIDGET />,
	},
	{
		path: adminMenu.analysis.subMenu.economicCalendar.path,
		element: <CLIENT_ANALYSIS.ECONOMICCALENDAR />,
	},
	{
		path: adminMenu.analysis.subMenu.ticker.path,
		element: <CLIENT_ANALYSIS.TICKER />,
	},
	// {
	// 	path: adminMenu.publicSettings.path,
	// 	element: <ADMIN_LANDING.PUBLICSETTINGS />,
	// },
	{
		path: adminMenu.reports.path,
		element: <ADMIN_REPORTS.REPORTSHUB />,
	},
	{
		path: adminMenu.reports.subMenu.transactionsReport.path,
		element: <ADMIN_REPORTS.TRANSACTIONSREPORT />,
	},
	{
		path: adminMenu.reports.subMenu.moneyTransactionsReport.path,
		element: <ADMIN_REPORTS.MONEYTRANSACTIONSREPORT />,
	},
	{
		path: adminMenu.reports.subMenu.usersDetailsReport.path,
		element: <ADMIN_REPORTS.USERSDETAILSREPORT />,
	},
	{
		path: adminMenu.reports.subMenu.firstDeposit.path,
		element: <ADMIN_REPORTS.FirstDeposit />,
	},
	{
		path: adminMenu.reports.subMenu.repeatedDeposit.path,
		element: <ADMIN_REPORTS.REPEATEDDEPOSIT />,
	},

	{
		path: adminMenu.reports.subMenu.todaysLiquidateAccount.path,
		element: <ADMIN_REPORTS.TODAYSLIQUIDATEACCOUNT />,
	},
	{
		path: adminMenu.reports.subMenu.activeAccountsWithFunds.path,
		element: <ADMIN_REPORTS.ACTIVEACCOUNTSWITHFUNDS />,
	},
	{
		path: adminMenu.reports.subMenu.semiInactiveAccounts.path,
		element: <ADMIN_REPORTS.SEMIIACTIVEACCOUNTS />,
	},
	{
		path: adminMenu.reports.subMenu.inactiveAccountsWithFunds.path,
		element: <ADMIN_REPORTS.INACTIVEACCOUNTSWITHFUNDS />,
	},
	{
		path: adminMenu.reports.subMenu.topXWinners.path,
		element: <ADMIN_REPORTS.TOPXWINNERS />,
	},
	{
		path: adminMenu.reports.subMenu.topXLoosers.path,
		element: <ADMIN_REPORTS.TOPXLOOSERS />,
	},
	{
		path: adminMenu.reports.subMenu.accountWithoutMoneyTransaction.path,
		element: <ADMIN_REPORTS.ACCOUNTWITHOUTMONEYTRANSACTION />,
	},

	{
		path: adminMenu.reports.subMenu.openPositionsReport.subMenu.detailedOpenPositionsReport
			.path,
		element: <ADMIN_REPORTS.DETAILEDOPENPOSITIONSREPORT />,
	},
	{
		path: adminMenu.reports.subMenu.historyReport.subMenu.detailedOpenHistoryReport.path,
		element: <ADMIN_REPORTS.DETAILEDOPENHISTORYREPORT />,
	},
	{
		path: adminMenu.reports.subMenu.historyReport.subMenu.detailedCloseHistoryReport.path,
		element: <ADMIN_REPORTS.DETAILEDCLOSEHISTORYREPORT />,
	},
	{
		path: adminMenu.reports.subMenu.pendingOrdersReport.path,
		element: <ADMIN_REPORTS.PENDINGORDERSREPORT />,
	},
	{
		path: adminMenu.reports.subMenu.financialStandingReport.subMenu
			.detailedFinancialStandingReport.path,
		element: <ADMIN_REPORTS.DETAILEDFINANCIALSTANDINGREPORT />,
	},
	{
		path: adminMenu.reports.subMenu.financialStandingReport.subMenu
			.financialStandingHistoryReport.path,
		element: <ADMIN_REPORTS.FINANCIALSTANDINGHISTORYREPORT />,
	},
	{
		path: adminMenu.reports.subMenu.OtpLogsReport.path,
		element: <ADMIN_REPORTS.OTPLOGSREPORT />,
	},
	{
		path: adminMenu.reports.subMenu.loginReport.path,
		element: <ADMIN_REPORTS.LOGINREPORT />,
	},
	{
		path: adminMenu.clickToCall.subMenu.dealerCallActivityReport.path,
		element: (
			<AdminRouteGuard permissionKey='dealerCallActivityReport'>
				<ADMIN_REPORTS.DEALERCALLACTIVITYREPORT />
			</AdminRouteGuard>
		),
	},
	{
		path: adminMenu.reports.subMenu.roboOrdersHistory.subMenu.openRoboOrdersHistory.path,
		element: <ADMIN_REPORTS.OPENROBOORDERSHISTORY />,
	},
	{
		path: adminMenu.reports.subMenu.roboOrdersHistory.subMenu.closeRoboOrdersHistory.path,
		element: <ADMIN_REPORTS.CLOSEROBOORDERSHISTORY />,
	},
	{
		path: adminMenu.reports.subMenu.withdrawRequestsReport.path,
		element: <ADMIN_REPORTS.WITHDRAWREQUESTSREPORT />,
	},
	{
		path: adminMenu.reports.subMenu.depositRequestReport.path,
		element: <ADMIN_REPORTS.DEPOSITREQUESTREPORT />,
	},
	{
		path: adminMenu.reports.subMenu.clientDepositSummaryReport.path,
		element: <ADMIN_REPORTS.CLIENTDEPOSITSUMMARYREPORT />,
	},
	{
		path: adminMenu.transactionalSmsProviders.path,
		element: (
			<AdminRouteGuard permissionKey='transactionalSmsProviders'>
				<ADMIN_LANDING.TRANSACTIONAL_SMS_PROVIDERS />
			</AdminRouteGuard>
		),
	},
	{
		path: adminMenu.reports.subMenu.failedDepositsReport.path,
		element: (
			<AdminRouteGuard permissionKey='failedDepositsReport'>
				<ADMIN_REPORTS.FAILEDDEPOSITSREPORT />
			</AdminRouteGuard>
		),
	},

	{
		path: adminMenu.reports.subMenu.loanRequestsReport.path,
		element: <ADMIN_REPORTS.LOANREQUESTSREPORT />,
	},
	{
		path: adminMenu.reports.subMenu.journalReport.path,
		element: <ADMIN_REPORTS.JOURNALREPORT />,
	},

	{
		path: adminMenu.withdraw.path,
		element: <ADMIN_LANDING.WITHDRAW />,
	},
	{
		path: adminMenu.deposit.path,
		element: <ADMIN_LANDING.DEPOSIT />,
	},
	{
		path: adminMenu.loan.path,
		element: <ADMIN_LANDING.LOAN />,
	},
	{
		path: adminMenu.mail.path,
		element: <ADMIN_LANDING.MAIL />,
	},
	{
		path: adminMenu.educationcenter.path,
		element: <ADMIN_LANDING.EDUCATIONCENTER />,
	},
	{
		path: '/admin/recentactivities',
		element: <ADMIN_LANDING.RECENTACTIVITIES />,
	},

	{
		path: demoPagesMenu.page404.path,
		element: <AUTH.PAGE_404 />,
	},
	{
		path: demoPagesMenu.login.path,
		element: <Login />,
	},
	{
		path: demoPagesMenu.encryptText.path,
		element: <EncryptText />,
	},
	{
		path: demoPagesMenu.forgotPassword.path,
		element: <ForgotPassword />,
	},
	{
		path: demoPagesMenu.resetPassword.path,
		element: <ResetPassword />,
	},
	{
		path: demoPagesMenu.createAccount.path,
		element: <CreateAccount />,
	},
	// {
	// 	path: demoPagesMenu.createAccount2.path,
	// 	element: <CreateAccount2 />,
	// },
	// {
	// 	path: demoPagesMenu.createAccount3.path,
	// 	element: <CreateAccount3 />,
	// },

	/** ************************************************** */

	/**
	 * Page Layout Types
	 */
	{
		path: pageLayoutTypesPagesMenu.blank.path,
		element: <PAGE_LAYOUTS.BLANK />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.headerAndSubheader.path,
		element: <PAGE_LAYOUTS.HEADER_SUBHEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyHeader.path,
		element: <PAGE_LAYOUTS.HEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlySubheader.path,
		element: <PAGE_LAYOUTS.SUBHEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyContent.path,
		element: <PAGE_LAYOUTS.CONTENT />,
	},
	{
		path: pageLayoutTypesPagesMenu.asideTypes.subMenu.defaultAside.path,
		element: <PAGE_LAYOUTS.ASIDE />,
	},
	{
		path: pageLayoutTypesPagesMenu.asideTypes.subMenu.minimizeAside.path,
		element: <PAGE_LAYOUTS.MINIMIZE_ASIDE />,
	},
];

const contents = [...presentation];

export default contents;
